import * as mediasoup from 'mediasoup-client';

export default class Sfu {

    constructor(params = {}) {

        this.iceServers = params.iceServers ? params.iceServers : {};
        this.iceTransportPolicy = params.iceTransportPolicy ? params.iceTransportPolicy : 'all';

        this.peerId = false;
        this.peerToken = false;

        this.closed = false;

        this.initParams = {};

        this.transports = [];
        this.services = [];

        this.id = Math.random().toString(36).substring(7);

    }

    async close() {
        for(var i in this.services) {
            try {
                await this.services[i].close2();
            }
            catch(err) {
                
            }
        }
        for(var i in this.transports) {
            await this.transports[i].close();
        }
    }

    async sig(endpoint, data, beacon) {
        try {
            data = { ...data, direction: this.direction, peerId: this.peerId, peerToken: this.peerToken }

            if (beacon) {
                window.navigator.sendBeacon(window.sdk.getApiUrl() + '/signaling/' + endpoint, JSON.stringify(data));
                return null;
            }
            return await window.sdk.fetch().post('/signaling' + endpoint, {
                body: data
            });
        }
        catch (e) {
            console.error(e);
        }
    }

    async start(direction, params = {}) {
        if (!this.started) {

            this.device = new mediasoup.Device();

            this.direction = direction;

            let { routerRtpCapabilities, peerId, peerToken } = await this.sig('/connect');

            this.peerId = peerId;
            this.peerToken = peerToken;

            if (!this.device.loaded) {
                await this.device.load({ routerRtpCapabilities });
            }
            this.transport = await this.createTransport(params);

            this.initParams = params;

            this.started = true;
        }
    }

    getId() {
        return this.peerId;
    }

    getToken() {
        return this.peerToken;
    }

    async manageClose() {      
        if(this.closingState)
            return;
        this.closingState = true;
        this.disconnectedPassed = true;
        this.showDisconnectPopin();
        this.transport.close();
        let check = false;
        console.log('************** manageClose **************', this.direction)
        while(!check) {
            await window.sdk.sleep(1000);
            let response = false;
            try {
                response = await window.fetch(
                    'https://' + window.sdk.getApiUrl() + '/check-network'
                );
                let json = await response.json();
            }
            catch(err) {
            
            }
            if(response) {
                check = true;
                window.sdk.event().emit('modalClose');
            }
        }
        this.started = false;
        this.start(this.direction, this.initParams);
        if(this.direction === 'send') {            
            await window.sdk.videoconf().restartProducer();
        }
        else {           
            await window.sdk.videoconf().restartConsumers();
        }
        this.closingState = false;
    }

    async createTransport(params) {
        let transport, { transportOptions } = await this.sig('/transport/create');

        if(window.sdk.getHocoSettings().forceTurn) {
            console.log('===============> TURN forceTurn', window.sdk.getHocoSettings().forceTurn)
            transportOptions.iceTransportPolicy = 'relay';
        }

        console.log('===============> TURN iceTransportPolicy', JSON.stringify(transportOptions.iceTransportPolicy), this.direction);
        

        if (this.direction === 'recv')
            transport = await this.device.createRecvTransport(transportOptions);
        else
            transport = await this.device.createSendTransport(transportOptions);

        transport.on('connect', async ({ dtlsParameters }, callback, errback) => {
            let { error } = await this.sig('/transport/connect', {
                transportId: transportOptions.id,
                dtlsParameters
            });

            if (error) {
                console.error('error', error)
                errback();
                return;
            }
            callback();
        });

        if (this.direction === 'send') {

            transport.on('produce', async ({ kind, rtpParameters, appData },
                callback, errback) => {

                let paused = false;
                let { error, id } = await this.sig('/producer/start', {
                    transportId: transportOptions.id,
                    kind,
                    rtpParameters,
                    paused,
                    appData
                });
                if (error) {
                    console.error('error setting up server-side producer', error);
                    errback();
                    return;
                }
                callback({ id });
            });
        }

        transport.on('connectionstatechange', async (connectionState) => {
            console.warn(connectionState, this.direction, this.id)
            if(this.closed) {
                this.manageClose();
                return;
            }

            if(connectionState == 'disconnected') {                
                this.manageClose();
            }            
        });

        this.transports.push(transport);

        return transport;
    }

    showDisconnectPopin() {
        window.sdk.event().emit('modalOpen', {
            variant: 'light',
            title: 'Problème de déconnexion',
            content: 'Il semblerait que vous ayez un problème de connexion. Nous tentons de vous reconnecter automatiquement au service'
        }); 
    }

    async startConsume(peerId, mediaTag, params = {}) {

        let consumerParameters = await this.sig('/consumer/start', {
            mediaTag,
            mediaPeerId: peerId,
            rtpCapabilities: this.device.rtpCapabilities
        });

        if (consumerParameters.error) {
            console.error('error', consumerParameters)
            return false;
        }

        let consumer = await this.transport.consume({
            ...consumerParameters
        });

        await this.sig('/consumer/resume', { consumerId: consumer.id });
        await consumer.resume();

        consumer.on('transportclose', () => {
        })

        consumer.on('trackended', () => {
        })

        consumer.pause2 = async () => {
            await this.sig('/consumer/pause', { consumerId: consumer.id });
            consumer.pause();
        }

        consumer.resume2 = async () => {
            await this.sig('/consumer/resume', { consumerId: consumer.id });
            consumer.resume();
        }

        consumer.close2 = async () => {
            this.closed = true;
            await this.sig('/consumer/close', { consumerId: consumer.id });
            consumer.close();
        }

        consumer.setPreferredLayers = async (preferredLayers) => {
            await this.sig('/consumer/set-layers', { consumerId: consumer.id, preferredLayers })
        }

        this.services.push(consumer);

        this.startConsumerStats(consumer, mediaTag);

        return consumer;
    }

    async startConsumerStats(consumer, mediaTag) {
        return;
        if(!consumer)
            return;
        try {
            let stats = await consumer.getStats();
            let log = [];
            stats.forEach((report) => {
                //console.log('report.type ', report.type )
                if (report.type == 'inbound-rtp') {
                    //console.log('report send', report);
                    log.push(report);
                }
            });
            //console.log('statsOutbound', statsOutbound);
            this.sig('/stats', { log, mediaTag });
            await window.sdk.sleep(3000);
            this.startConsumerStats(consumer, mediaTag);
        }
        catch(e) {
            //console.error(e);
        }
    }

    /*async setPreferredLayers(consumerId, spatialLayer) {
        await this.sig('/consumer/set-layers', { consumerId, spatialLayer })
    }*/

    async startProduce(track, mediaTag, params = {}) {
        let producer = await this.transport.produce({
            track: track,
            encodings: params.encodings,
            codecOptions: params.codecOptions,
            stopTracks: false,
            appData: Object.assign({ mediaTag }, params.appData)
        });

        producer.pause2 = async () => {
            await this.sig('/producer/pause', { producerId: producer.id });
            producer.pause();
        }

        producer.resume2 = async () => {
            await this.sig('/producer/resume', { producerId: producer.id });
            producer.resume();
        }

        producer.close2 = async () => {
            this.closed = true;
            await this.sig('/producer/close', { producerId: producer.id });
            producer.close();
        }

        producer.serverClose = async () => {
            await this.sig('/producer/close', { producerId: producer.id });
        }

        producer.on('transportclose', () => {
            producer = null;
        });

        producer.on('trackended', () => {
        });

        this.services.push(producer);

        this.startProducerStats(producer, mediaTag);
        
        return producer;
    }

    async startProducerStats(producer, mediaTag) {
        return;
        if(!producer)
            return;
        try {
            let stats = await producer.getStats();
            let log = [];
            stats.forEach((report) => {
                //console.log('report.type ', report.type )
                if (report.type == 'outbound-rtp') {
                    //console.log('report send', report);
                    log.push(report);
                }
            });
            //console.log('statsOutbound', statsOutbound);
            this.sig('/stats', { log, mediaTag });
            await window.sdk.sleep(3000);
            this.startProducerStats(producer, mediaTag);
        }
        catch(e) {
            //console.error(e);
        }
    }

    async leave() {
        await this.sig('/leave');
    }


}
